export default __webpack_public_path__ + "static/image/image006.6a09a237.jpg";